export const renderInModal = (content) => {
  const modalContentEl = document.querySelector('.a-modal__content');
  modalContentEl.innerHTML = content;
}

export const clearModalContent = () => {
  const modalContentEl = document.querySelector('.a-modal__content');
  modalContentEl.innerHTML = "";
}
